import { Container, Group, Title, Text, useMantineTheme, useMantineColorScheme} from "@mantine/core";

interface DashboardHeaderProps {
  title: string;
  subtitle?: string;
}

export default function DashboardHeader({ title, subtitle }: DashboardHeaderProps) {
  const theme = useMantineTheme();
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";

  return (
    <Container
      fluid
      py={{ base: "sm", sm: "md" }}
      px={{ base: "sm", sm: "lg" }}
      className={`border-b ${isDark ? "border-gray-700" : "border-gray-300"}`}
    >
      <div>
        <Title order={2} size="h3" className="sm:text-2xl" c={isDark ? theme.colors.gray[3] : theme.black}>
          {title}
        </Title>
        {subtitle && (
          <Text size="sm" mt={4} c={isDark ? "gray.5" : "gray.6"}>
            {subtitle}
          </Text>
        )}
      </div>
    </Container>
  );
}
 